<div class="container-fluid service-bg from-top-pad">
    <div class="row">
        <div class="col-md-12">
            <h1>
                {{'gen_viewing_history' | translate}}
                <i class="fa fa-trash float-right pl-3 cursor-po-c" matTooltip="{{'gen_delete' | translate}}" matTooltipClass="theme-tooltip" (click)="deleteItems()"></i>
            </h1>
        </div>
        <div class="col-md-12 my-5 clr-sec-text text-center" *ngIf="!assets?.length">
            <h2>{{'gen_no_data' | translate}}</h2>
        </div>
        <div class="col-md-12 my-3" infiniteScroll [infiniteScrollDistance]="2" (scrolled)="onScroll()" *ngIf="assets?.length">
            <div class="table-container">
                <table mat-table [dataSource]="assets" class="mat-elevation-z8 w-100">
                    <!-- Checkbox Column -->
                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef>
                            <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                            </mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let row">
                            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                            </mat-checkbox>
                        </td>
                    </ng-container>

                    <!-- Position Column -->
                    <ng-container matColumnDef="position">
                        <th mat-header-cell *matHeaderCellDef> No. </th>
                        <td mat-cell *matCellDef="let element;let i = index;">
                            {{i + 1}} </td>
                    </ng-container>

                    <!-- Date Column -->
                    <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef> {{'gen_date' | translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.updated | momentPipe:'DD/MM/YYYY'}} </td>
                    </ng-container>

                    <!-- Name Column -->
                    <ng-container matColumnDef="title">
                        <th mat-header-cell *matHeaderCellDef> {{'gen_title' | translate}} </th>
                        <td mat-cell *matCellDef="let element">
                            <a *ngIf="element.assetExists" [href]="'#/details/' + (element.bookmarkInfo.seriesId ? element.bookmarkInfo.seriesId : element.bookmarkInfo.assetId)">
                            {{element.assetTitle}} 
                        </a>
                            <span *ngIf="!element.assetExists">
                            {{element.assetTitle}} 
                        </span>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </div>
        </div>
    </div>
</div>